import React from "react";

// A reusable page banner: small eyebrow label, big heading, short subtitle,
// and an optional call-to-action. Used by FAQ, Privacy, Terms, Contact,
// Blog, Lifestyle, Shop, and About so every inner page shares one look.
export default function PageHero({ eyebrow, title, subtitle, cta }) {
  return (
    <header className="services-hero">
      <div className="container text-center">
        {eyebrow && <div className="mu-eyebrow on-purple">{eyebrow}</div>}
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {cta}
      </div>
    </header>
  );
}
